export default "__VITE_ASSET__Cx58oow9__"